export default "__VITE_ASSET__Cya0Wvir__"